export class PoQty{
   // poQty:number;
   totalItemQuantity: number;
    
}